<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Test Results (Post-Transplant): Biopsy Tests
        </h2>

        <ul class="list-disc pl-4  font-light text-2xl mb-6">
            <li>
                <span class="font-semibold">Due to suspected allograft rejection, a kidney biopsy was performed</span>
                <ul class="list-inside list-['-_'] pl-6">
                    <li>
                        Ultrasound-guided kidney graft needle biopsy was conducted on post-operative Day 21
                        <ul class="list-inside list-['-_'] pl-6">
                            <li>Borderline acute rejection and deposition of <span class="font-semibold">CaOx crystals</span> were detected in the allograft</li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>

        <div class="flex flex-col md:flex-row gap-6">
            <div class="p-6 bg-lightblue50 flex-1">
                <h5 class="text-2xl font-semibold">Borderline acute rejection of the allograft was detected <br />(HE stain, ×200 magnification) </h5>
                <img
                    src="@/assets/img/graphics/transplant/left.svg"
                    alt="Acute rejection"
                    class="block object-contain w-full mt-6"
                />
            </div>

            <div class="p-6 bg-green50 flex-1">
                <h5 class="text-2xl font-semibold">Extensive CaOx crystal deposition in the interstitial tubule was detected (polarized light ×200 [left] and ×400 [right] magnification)</h5>
                <img
                    src="@/assets/img/graphics/transplant/right.svg"
                    alt="Crystal deposition"
                    class="block object-contain w-full mt-6"
                />
            </div>
        </div>
    </div>
</template>
